import AbsenceAcceptDetails from './absence-accept-details'

export default AbsenceAcceptDetails
